import axios from 'axios';

import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function updateBookingGuests(bookingId, guests) {
  return axios.post(`${baseURL}/api/v1/guests`, { bookingId, guests });
}

export function getBookingGuests(bookingId) {
  return axios.get(`${baseURL}/api/v1/guests/${bookingId}`);
}

export function queryDownloadInvoice(bookingId) {
  return axios.get(`${baseURL}/api/v1/guests/${bookingId}/invoice`, { responseType: 'blob' });
}

export function queryDownloadInvoicePresent(presentId) {
  return axios.get(`${baseURL}/api/v1/guests/${presentId}/invoice/present`, { responseType: 'blob' });
}

export function addTuristicTax(bookingId, flag) {
  return axios.put(`${baseURL}/api/v1/guests/invoice/tax`, { bookingId, flag });
}

export function saveExtras(bookingId, extras) {
  return axios.put(`${baseURL}/api/v1/guests/invoice/extras`, { bookingId, extras });
}

export function getExtras(bookingId) {
  return axios.get(`${baseURL}/api/v1/guests/${bookingId}/invoice/extras`);
}



// WEBPACK FOOTER //
// ./src/services/guests.js